import React, {FC, useEffect, useState} from "react";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import {
    createClickableLink,
    SearchSelectWithIndeterminateBoolean
} from "../../../../components/common/datatable/DataTableUtils";
import {useFindUserSettingsByGroupNameQuery} from "../../../../components/common/userSetting/userSettingsApi";
import {SearchInputWrapper} from "../../../../components/common/datatable/filter/SearchInputWrapper";
import {getBooleanDisplayIcon} from "../../../../helpers/utils/Utils";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import {DataTable} from "../../../../components/common/datatable/DataTable";
import {useSearchTenantsQuery} from "../tenantApi";

const Tenants: FC = () => {

    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "Tenants", url: ""}
    ])
    useEffect(() => {
        document.title = "Tenants"
    }, []);
    const {data: userSettings} = useFindUserSettingsByGroupNameQuery("System Property");
    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "name", visibility: {hasShowSetting: false},
            cell: (props: any) => {
                let path = `/tenant/${props.row.original.id}`;
                return createClickableLink(path, props.value, userSettings, false, "", ["TEN-V"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."} name={"name"}
                                                     accessor={"tenantName"}/>,
                overrideFilterLabel: "Tenant Name",
                overrideFilterAccessor: "tenantName"
            }]
        },

        {
            label: "URL", accessor: "baseUrl", visibility: {hasShowSetting: false},
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter baseUrl..."} name={"baseUrl"}
                                                     accessor={"baseUrl"}/>,
                overrideFilterLabel: "Base Url",
            }]
        },
        {
            label: "Is Primary", accessor: "primaryTenant",
            cell: (props: any) => getBooleanDisplayIcon(props.row.original.primaryTenant, "Enabled", "Disabled"),
            filterOptions: [{
                filterComponent: SearchSelectWithIndeterminateBoolean("Select Is Primary...", "primaryTenant"),
            }]
        },

    ]

    return (
        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs}/>
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchTenantsQuery
                }}
                userSettingGroup={"Tenants"}
                defaultFilter={{
                    sort:"name",
                    sortOrder:"ASCENDING"
                }}
            />

        </div>

    )
}
export default Tenants;